import { render, staticRenderFns } from "./PartnerCarousel.vue?vue&type=template&id=5a8d23b1&"
import script from "./PartnerCarousel.vue?vue&type=script&lang=js&"
export * from "./PartnerCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports